export const RECALCULATE_PRICE = 'RECALCULATE_PRICE';
export const REDUCER_RECALCULATE_PRICE = 'REDUCER_RECALCULATE_PRICE';

export const recalculatePrice = (totalPrice: number) => ({
  type: REDUCER_RECALCULATE_PRICE,
  data: {
    totalPrice
  }
});
